import React from 'react';
import styled from 'styled-components';

import LoginContainer from 'components/containers/login/LoginContainer';

const LoginLayout = () => {
    return (
        <LoginSection>
            <LoginContainer />
        </LoginSection>
    );
}

const LoginSection = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
`;

export default LoginLayout;